export function BannerPortafolio() {
    return (
        <div className="banner-portfolio m-auto col-lg-7 d-flex justify-content-center align-items-center">
            <div className=" banner-portfolio__box d-flex align-items-center">
                <div className="banner-portfolio__box__content">
                    <div className="banner-portfolio__box__content__container">
                        <p className="banner-portfolio__box__content__container__text">
                            Hello
                        </p>

                        <ul className="banner-portfolio__box__content__container__list content__container__list">
                            <li className="banner-portfolio__box__content__container__list__item">world!</li>
                            <li className="banner-portfolio__box__content__container__list__item">coders!</li>
                            <li className="banner-portfolio__box__content__container__list__item">users!</li>
                            <li className="banner-portfolio__box__content__container__list__item">friends!</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}